import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import { RendererProps } from "../BaseRenderer";
import useStyle from "./HeatMapSelectionRenderer.styles";

interface Props extends RendererProps {
    top: string;
    left: string;
    width?: string;
    height?: string;
    color: string;
    borderWidth: string;
    variableName?: string;
    areaCode?: string;
    onSelect?(index: any): void;
    index?: number;
}

export default function ImageAreaSelectionRenderer(props: Props) {
    const divRef = React.useRef();
    const { index, variableName, onSelect } = props;
    const theme = useTheme();
    const classes = useStyle({ theme });
    // Style-specific props
    const { top, left, color, areaCode, borderWidth } = props;
    const border =
        (!borderWidth ? 1 : borderWidth) +
        "px solid " +
        (!color || color == "" ? "#000000" : color);
    const style = {
        top: top || "0px",
        left: left || "0px",
        border: border || "1px solid black",
    };

    const [active, setActive] = React.useState(false);

    return (
        <div
            id={variableName}
            data-areacode={areaCode}
            ref={divRef}
            role="checkbox"
            tabIndex={0}
            data-index={index}
            className={classnames(
                classes.imageAreaSelection,
                active && classes.imageAreaSelectionActive,
            )}
            onMouseDown={(event) => {
                onSelect(index);
                event.preventDefault();
            }}
            onFocus={() => setActive(true)}
            onMouseOver={() => setActive(true)}
            onMouseOut={() => setActive(false)}
            style={style}
        />
    );
}
